import { InputNumber } from "primereact/inputnumber";
import "./style.scss";

const InputNumberUI = (props) => {
    return (
        <div className={"detail__item input-number-ui " + props.addClass}>
            {props.label && (
                <label className={props?.dataId?.join("-")} data-pr-tooltip={props.label}>
                    {props.label}
                    {props.required ? "*" : ""}
                </label>
            )}
            <InputNumber {...props} />
        </div>
    );
};

export default InputNumberUI;
